import { getAccessToken } from './manageAccessToken';

/**
 * Returns true when there is an active access token in memory.
 * Use as a fast in-session gate only — actual session validity is determined by
 * the backend when the token is used. Returns false after a page reload; the
 * authenticated route guard will attempt a cookie-based token refresh instead.
 */
export const isAuthenticated = () => Boolean(getAccessToken());
